import React from "react";
import Report from "../components/Report";
import Table from "../../../components/TableX";
import { useLazyQuery, API } from "../../../api";
import * as dateFns from "date-fns";

export default function GeneralLedger() {
  const [getReport, { data, loading }] = useLazyQuery(API.GET_GENERAL_LEDGER, {
    fetchPolicy: "network-only",
  });

  const [filters, setFilters] = React.useState({
    startDate: dateFns.startOfMonth(new Date()),
    endDate: dateFns.endOfMonth(new Date()),
  });

  React.useEffect(() => {
    getReport({ data: filters });
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    getReport({ data: filters });
    // eslint-disable-next-line
  }, [filters]);

  const onDateRangeChange = ({ startDate, endDate }) => {
    setFilters({ ...filters, startDate, endDate });
  };

  const columns = [
    { name: "account", label: "Account", options: { align: "left" } },
    { name: "debit", label: "Debit", options: { align: "right", money: true } },
    {
      name: "credit",
      label: "Credit",
      options: { align: "right", money: true },
    },
    {
      name: "balance",
      label: "Balance",
      options: { align: "right", money: true },
    },
  ];

  return (
    <Report
      title="General Ledger"
      useDateRange
      onDateRangeChange={onDateRangeChange}
      startDate={filters?.startDate}
      endDate={filters?.endDate}
      data={data}
      columns={columns}
    >
      <Table data={data} columns={columns} isLoading={loading} />
    </Report>
  );
}
